import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../../twc.refresh-layer-plugin.service';
import { MVFR_FLIGHT_RULES_PRODUCT_DATA } from './flight-rules-mvfr.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class FlightRulesMvfrPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);
  plugin$ = this._twcPluginService.create(MVFR_FLIGHT_RULES_PRODUCT_DATA, {
    twcLayerTypes: ['web-tile']
  });
}
